import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { FactoryWeightPointFilteringSchema } from '../FactoryWeightPointSchema';
import { FactoryWeightPointListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import collectionCatagoryService from '../../CollectionCategory/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import routeService from '../../Route/services';

const screenCode = 'FACTORYWEIGHPOINT';

export function FactoryWeightPointFiltering(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Factory Weight Point");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [collectionCatagory, setCollectionCatagory] = useState();
    const [factoryWeightPointFilteringData, setFactoryWeightPointFilteringData] = useState([]);
    const [factoryWeightPointFiltering, setFactoryWeightPointFiltering] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionCatagoryID: '0',
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(FactoryWeightPointFilteringSchema).options({ allowUnknown: true });

    useEffect(() => {
trackPromise(
        getGroupsForDropdown()
)
        getPermissions();
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
            )
    }, [factoryWeightPointFiltering.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCatagoryForDropDown()
            )
    }, [factoryWeightPointFiltering.operationEntityID])

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYWEIGHPOINTLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITFACTORYWEIGHPOINT');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setFactoryWeightPointFiltering({
            ...factoryWeightPointFiltering,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropdown();
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntities = await routeService.getFactoryByGroupID(factoryWeightPointFiltering.groupID);
        setOperationEntity(operationEntities);
    }

    async function getCollectionCatagoryForDropDown() {
        const collectionCatagory = await collectionCatagoryService.GetCollectionCategoryByOperationEntityID(factoryWeightPointFiltering.operationEntityID);
        setCollectionCatagory(collectionCatagory);
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, FactoryWeightPointFilteringSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setFactoryWeightPointFiltering({
            ...factoryWeightPointFiltering,
            [e.target.name]: value
        });
        setErrors(error);

        setFactoryWeightPointFilteringData([]);

    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, factoryWeightPointFiltering);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const response = await services.getAllCollectionPointsByFilter(factoryWeightPointFiltering);
        setFactoryWeightPointFilteringData(response);
    }

    async function editfactoryWeightPointFiltering(data) {
        props.history.push({
            pathname: 'factoryweightpoint/AddEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setFactoryWeightPointFiltering({
            ...factoryWeightPointFiltering,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionCatagoryID: '0',
        });
       setFactoryWeightPointFilteringData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="factoryweightpoint/AddEdit"
                                    buttonText="Add Factory Weight Point"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            id="groupID"
                                            name="groupID"
                                            value={factoryWeightPointFiltering.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={factoryWeightPointFiltering.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCatagoryID">Collection Category * </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCatagoryID"
                                            id="collectionCatagoryID"
                                            name="collectionCatagoryID"
                                            value={factoryWeightPointFiltering.collectionCatagoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Catagory--</MenuItem>
                                            {generateDropDownMenu(collectionCatagory)}
                                        </Select>
                                        {errors["collectionCatagoryID"] && <FormHelperText error>{errors["collectionCatagoryID"]}</FormHelperText>}
                                    </div>
                                    
                                </div>

                                <div className="card-footer">
                                    <input
                                        //disabled={validate(schema, FactoryWeightPoint)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                {factoryWeightPointFilteringData && factoryWeightPointFilteringData.length > 0 && (
                                    <FactoryWeightPointListing 
                                        factoryWeightPointFilteringData={factoryWeightPointFilteringData} 
                                        handleClick={editfactoryWeightPointFiltering} 
                                        editEnabled={permissionList.isAddEditEnabled}
                                    />
                                )}

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}